import contentfulGql from 'js/lib/contentfulGql';

export const getAllExtraMetadataQuery = contentfulGql`#graphql
query AllExtraMetadata(
    $degreeSlugs: [UniversityProgramPageContentFilter]
    $mastertrackSlugs: [PremiumCertificatePageContentFilter]
    $locale: String!
) {
  universityProgramPageContentCollection(locale: $locale, where: { OR: $degreeSlugs }) {
    items {
      slug
      atAGlance {
        timeFrame
      }
    }
  }
  premiumCertificatePageContentCollection(locale: $locale, where: { OR: $mastertrackSlugs }) {
    items {
      slug
      atAGlance {
        timeFrame
      }
    }
  }
}
`;

export default getAllExtraMetadataQuery;
